
import { useContext, Suspense } from "react"

import { Navigate } from "react-router-dom"

// ** Context Imports
import { AbilityContext } from "@src/utility/context/Can"
import { AuthContext } from '@context/AuthContext'

const PrivateRoute = ({ children, route }) => {
  // ** Hooks & Vars
  const ability = useContext(AbilityContext)
  const user = JSON.parse(localStorage.getItem("userData"))

  const { userDetail, paymentdue } = useContext(AuthContext)

  if (route) {
    let action = null
    let resource = null
    let restrictedRoute = false

    if (route.meta) {
      action = route.meta.action
      resource = route.meta.resource
      restrictedRoute = route.meta.restricted
    }
    if (Object.keys(userDetail).length === 0) {
      return <Navigate to="/login" />
    }

    /**
     * Оюутны төлбөрийн нэхэмжлэлийг шахах нөхцөл
    */
    //  Сургалтын албаны хүсэлтээр commit хийв Дараагийн хичээлийн жилээс нээн
    if (!userDetail?.contract_url) {
      return <Navigate to="/contract" />
    }

    // "Сэтгэл ханамжийн судалгаа" хийх ёстой эсэх
    // to check using "userDetail?.is_soul_survey_not_filled" because in "state" way it will not be updated to actual value sometimes
    if (userDetail?.is_soul_survey_not_filled) {
      return <Navigate to="/survey/soul-survey-fill" />
    }

    /**
     * Оюутны төлбөрийн нэхэмжлэлийг шахах нөхцөл
    */
    if (
      Object.keys(userDetail).length > 0 && paymentdue &&
      route.path !== "/paymentdue" &&
      (route.path === "base/" || route.path === "/base")
    ) {
      return <Navigate to="/paymentdue" />
    }

    if (userDetail?.is_default_password == true) {
      if(userDetail?.student?.code) localStorage.setItem("mycode", userDetail?.student?.code)
      return <Navigate to="/change-password" />
    }

   // useEffect(
    //     () =>
    //     {
    //         if (Object.keys(userDetail).length != 0)
    //         {
    //             if (userDetail?.is_default_password == true)
    //             {
    //                 navigate('/change-password')
    //             }
    //         }
    //     },
    //     [userDetail]
    // )

    if (Object.keys(userDetail).length === 0 && restrictedRoute) {
      return <Navigate to="/" />
    }
    if (user && restrictedRoute && user.role === "client") {
      return <Navigate to="/access-control" />
    }
    // if (user && !ability.can(action || "read", resource)) {
    //   return <Navigate to="/misc/not-authorized" replace />
    // }
  }

  return <Suspense fallback={null}>{children}</Suspense>
}

export default PrivateRoute
